import React from "react";
import noise from "../contents/dev/noise.png";

export default function AboutUs() {
    return (
        <div className="flex-grow bg-black w-full">
            {/* overflow-hidden */}
            <div className="content content-padding flex flex-wrap justify-center">
                <div className="lg:hidden block text-4xl font-medium pt-12 px-12 2xl:px-0 2xl:pr-12">
                    <div className="text-white">
                        Get to <span className="text-yellow-400"> Know Us </span>
                    </div>
                    <div className="text-white">
                        We have <span className="text-yellow-400"> No Borders </span>
                    </div>
                </div>
                <div className="flex flex-row flex-wrap-reverse justify-center lg:py-24 py-12">

                    <div className="text-white space-y-10 lg:w-1/2 w-full px-12 2xl:px-0 2xl:pr-12">
                        <div className="lg:block hidden text-4xl font-medium">
                            <div>
                                Get to <span className="text-yellow-400"> Know Us </span>
                            </div>
                            <div>
                                We have <span className="text-yellow-400"> No Borders </span>
                            </div>
                        </div>
                        <div className="font-light space-y-10">
                            <div>
                                3dotstudio is a dev studio working with Unreal Engine, AWS/GameLift, Azure, or building
                                custom
                                backend to suit your game
                            </div>
                            <div>
                                We have had a lot of success collaborating with an amazing team of experienced top
                                artists
                                on
                                our latest projects and decided to keep going as one team now to make the creation of
                                your
                                game
                                much smoother.
                            </div>
                            <div>
                                We will bring experience, enthusiasm, and a great atmosphere as individuals who love
                                their
                                craft
                                and work hard to make your game come alive.
                            </div>
                        </div>
                    </div>
                    <div className="w-1/2">
                        <img className="object-cover" src="/images/People.jpg" alt=''/>
                    </div>

                </div>
                <div className="flex sm:w-1/2 md:w-full flex-wrap justify-center gap-x-12 mx-4 md:mx-0">
                    <div className="relative flex my-12">
                        <div className="card bg-gray-1 text-white p-6" style={{backgroundImage: `url(${noise})`}}>
                            <div className="py-4 text-xl font-medium border-gray-2 border-b-2">
                                Our vision:
                            </div>
                            <div className="py-4 font-light">
                                To provide successful partnerships, bringing high-quality communication and results with
                                positive thinking.
                            </div>
                        </div>
                        <div className="card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                        <div className="absolute left-32 bottom-52 p-2 flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400">
                            <svg width="56" height="56" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M30.4688 2V10.39" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M6.5 9.22998L12.43 15.16" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M53.43 9.22998L47.5 15.16" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M30.4688 58.9999V50.6099" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M6.5 51.7698L12.43 45.8398" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M53.43 51.7698L47.5 45.8398" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M58.93 30.7099C58.93 30.7099 45.96 15.1699 30.46 15.1699C14.96 15.1699 2 30.4999 2 30.4999C2 30.4999 15.63 46.2499 30.3 46.2499C44.97 46.2499 58.94 30.7099 58.94 30.7099H58.93Z" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M26.5 21.3898C27.72 20.8598 29.06 20.5698 30.47 20.5698C35.97 20.5698 40.44 25.0398 40.44 30.5398C40.44 36.0398 35.97 40.5098 30.47 40.5098C24.97 40.5098 20.5 36.0398 20.5 30.5398C20.5 29.8498 20.57 29.1898 20.7 28.5398" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M30.47 34.5001C32.6626 34.5001 34.44 32.7226 34.44 30.5301C34.44 28.3375 32.6626 26.5601 30.47 26.5601C28.2774 26.5601 26.5 28.3375 26.5 30.5301C26.5 32.7226 28.2774 34.5001 30.47 34.5001Z" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M23.4609 26C24.2894 26 24.9609 25.3284 24.9609 24.5C24.9609 23.6716 24.2894 23 23.4609 23C22.6325 23 21.9609 23.6716 21.9609 24.5C21.9609 25.3284 22.6325 26 23.4609 26Z" fill="#FACC15"/>
                            </svg>
                        </div>
                    </div>

                    <div className="relative flex my-12 ">
                        <div className="card bg-gray-1 text-white p-6" style={{backgroundImage: `url(${noise})`}}>
                            <div className="py-4 text-xl font-medium border-gray-2 border-b-2">
                                Our mission:
                            </div>
                            <div className="py-4 font-light">
                                For clients, employees, investors, and partners: our mission is to make people fulfilled
                                and happy working with us.
                            </div>
                        </div>
                        <div className="card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                        <div className="absolute left-32 bottom-52 p-2 flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400">
                            <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M57.5509 21.62C58.4609 24.41 58.9609 27.4 58.9609 30.5C58.9609 46.24 46.2009 59 30.4609 59C14.7209 59 1.96094 46.24 1.96094 30.5C1.96094 14.76 14.7209 2 30.4609 2C33.5109 2 36.4409 2.48 39.2009 3.36" stroke="#FACC15" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"/>
                                <path d="M49.9209 29.22C49.9509 29.64 49.9609 30.07 49.9609 30.5C49.9609 41.25 41.2109 50 30.4609 50C19.7109 50 10.9609 41.25 10.9609 30.5C10.9609 19.75 19.7109 11 30.4609 11C30.8209 11 31.1909 11.01 31.5409 11.03" stroke="#FACC15" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"/>
                                <path d="M40.9609 30.5C40.9609 36.29 36.2509 41 30.4609 41C24.6709 41 19.9609 36.29 19.9609 30.5C19.9609 24.71 24.6709 20 30.4609 20" stroke="#FACC15" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"/>
                                <path d="M30.4609 30.5001L40.9609 20.0001V14.0001L49.9609 5.33008V11.0001H55.8009L46.9609 20.0001H41.9609" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}